import { useEffect, useState } from "react";
import TitleBox from "../../components/Common/TitleBox";
import { ContractTemplateInfo } from "../../system/types/interface";
import { ContractTemplateApi, ErrorHandler } from "../../system/ApiService";

import { useHistory } from "react-router-dom";
import AlertModal from "../../components/Common/AlertModal";
import ContractTemplateDetailBoard from "../../components/ContractTemplate/ContractTemplateDetailBoard";

interface ContractTemplateProps {
  location: any;
}

function ContractTemplateDetail({ location }: ContractTemplateProps) {
  const [id, setId] = useState(0);
  const [data, setData]: any = useState<ContractTemplateInfo[]>([]);
  let history = useHistory();

  useEffect(() => {
    if (location.state.displays) {
      setId(Number(location.state.displays));
      const id = Number(location.state.displays);
      ContractTemplateApi.GetContractTemplate(id)
        .then((res) => {
          setData(res.data);
        })
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    } else {
      history.goBack();
    }
  }, [id]);

  // 데이터 받을 때마다 조회수 증가
  useEffect(() => {
    const newData: ContractTemplateInfo = {
      contractTemplateTitle: data.contractTemplateTitle,
      contractTemplateContent: data.contractTemplateContent,
      contractTemplateModifiedAt: data.contractTemplateModifiedAt,
      contractTemplateWriter: data.contractTemplateWriter,
      contractTemplateId: data.contractTemplateId,
      contractTemplateCreatedAt: data.contractTemplateCreatedAt,
      contractTemplateViews: data.contractTemplateViews + 1,
      teamName: data.teamName,
      fileuploadFolder: data.fileuploadFolder,
      employeeId: data.employeeId,
    };
    if (data.contractTemplateTitle) {
      ContractTemplateApi.UpdateContractTemplate(newData)
        .then(() => {})
        .catch((error) => {
          let msg = ErrorHandler(error);
          AlertModal("msg", msg);
        });
    }
  }, [data]);

  return (
    <div>
      <TitleBox title="계약서 양식" />
      <ContractTemplateDetailBoard data={data} />
    </div>
  );
}

export default ContractTemplateDetail;
